/* FLC Forge — Manuals Library (DEV-292) */
(function () {
  if (customElements.get('manuals-library')) return;

  var CACHE_KEY = 'flc:manuals:v1';
  var DEBOUNCE_MS = 250;
  var MIN_CHARS = 2;
  /* Browse index: how many 50-product pages of /collections/all to walk.
     7 pages today — the all-products collection holds the ~330 published
     products, not all 533, because unlisted ones never appear in it. The cap
     stops a runaway if the catalogue grows a lot; raise it rather than letting
     manuals silently fall off the end. */
  var MAX_BROWSE_PAGES = 20;
  /* Live search: extra pages to pull when page 1 came back thin on manuals.
     Broad terms ("sofa") match hundreds of products, ~10% of which have a
     PDF, so page 1 alone can look emptier than the truth. */
  var SEARCH_PAGE_CAP = 4;
  var SEARCH_WANT = 12;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* Collapse case, spaces and dashes so "ha 833-057 aus" finds HA833057AUS. */
  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/[\s\-_/]+/g, '');
  }

  function highlight(text, term) {
    var out = esc(text);
    if (!term) return out;
    var safe = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    try {
      return out.replace(new RegExp('(' + safe + ')', 'ig'), '<mark>$1</mark>');
    } catch (e) {
      return out;
    }
  }

  /* Relevance score for a search hit. Shopify's search also matches the body
     description, so a query like "bed" returns a pile of sofas whose copy
     mentions a sofa bed. Sorting those alphabetically buried the actual bed
     six rows down — rank instead, and only fall back to Shopify's own order
     inside a tie. */
  function score(m, lq, nq) {
    var nsku = norm(m.s);
    var title = String(m.t || '').toLowerCase();
    if (nsku === nq) return 100;
    if ((' ' + String(m.s || '').toLowerCase() + ' ').indexOf(' ' + lq + ' ') !== -1) return 100;
    if (nsku.indexOf(nq) !== -1) return 70;
    if (title.indexOf(lq) === 0) return 50;
    if (title.indexOf(' ' + lq) !== -1) return 40;
    if (title.indexOf(lq) !== -1) return 30;
    if (String(m.c || '').toLowerCase().indexOf(lq) !== -1) return 20;
    return 0; /* description-only match — keep it, but last */
  }

  var FILE_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>' +
    '<polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/>' +
    '<line x1="8" y1="17" x2="13" y2="17"/></svg>';

  var ManualsLibrary = function () {
    return Reflect.construct(HTMLElement, [], ManualsLibrary);
  };
  ManualsLibrary.prototype = Object.create(HTMLElement.prototype);
  ManualsLibrary.prototype.constructor = ManualsLibrary;
  Object.setPrototypeOf(ManualsLibrary, HTMLElement);

  ManualsLibrary.prototype.connectedCallback = function () {
    this.input = this.querySelector('[data-manuals-input]');
    this.clearBtn = this.querySelector('[data-manuals-clear]');
    this.results = this.querySelector('[data-manuals-results]');
    this.statusEl = this.querySelector('[data-manuals-status]');
    this.browseUrl = this.dataset.browseUrl;
    this.searchUrl = this.dataset.searchUrl;

    this.index = null;
    this.indexComplete = false;
    this.timer = null;
    this.controller = null;
    this.term = '';

    var self = this;
    this.input.addEventListener('input', function () { self.onInput(); });
    this.input.addEventListener('search', function () { self.onInput(); });
    this.clearBtn.addEventListener('click', function () {
      self.input.value = '';
      self.input.focus();
      self.onInput();
    });
    /* Don't let Enter submit anything — there's no form, but iOS keyboards
       still fire it and a stray reload would drop the index. */
    this.input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') e.preventDefault();
    });

    window.addEventListener('popstate', function () {
      self.input.value = self.readQueryParam();
      self.onInput(true);
    });

    var initial = this.readQueryParam();
    if (initial) this.input.value = initial;

    this.loadIndex().then(function () {
      if (self.input.value.trim()) self.onInput(true);
      else self.renderBrowse();
    });
  };

  ManualsLibrary.prototype.readQueryParam = function () {
    try {
      return new URLSearchParams(window.location.search).get('q') || '';
    } catch (e) { return ''; }
  };

  ManualsLibrary.prototype.writeQueryParam = function (q) {
    try {
      var url = new URL(window.location.href);
      if (q) url.searchParams.set('q', q);
      else url.searchParams.delete('q');
      window.history.replaceState({}, '', url.toString());
    } catch (e) { /* non-fatal */ }
  };

  /* NO Accept HEADER. Sending `Accept: text/plain` makes Shopify answer these
     alternate views with a bare 404 "Not Found" — verified on the DEV theme,
     2026-09-21: the identical URL returns 200 with no headers or with
     Accept: text/html. Leave the default alone. */
  ManualsLibrary.prototype.fetchJson = function (url, signal) {
    return fetch(url, { signal: signal })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (t) { return JSON.parse(t.trim()); });
  };

  /* ---- Browse index -------------------------------------------------- */

  ManualsLibrary.prototype.loadIndex = function () {
    var self = this;

    try {
      var cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        this.index = JSON.parse(cached);
        this.indexComplete = true;
        return Promise.resolve(this.index);
      }
    } catch (e) { /* private mode / blocked storage — just refetch */ }

    return this.fetchJson(this.browseUrl + '&page=1')
      .then(function (first) {
        self.index = (first.results || []).slice();

        var pages = Math.min(first.pages || 1, MAX_BROWSE_PAGES);
        if (pages < 2) {
          self.indexComplete = true;
          self.cacheIndex();
          return self.index;
        }

        /* Page 1 is enough to paint something; the rest stream in behind it. */
        if (!self.input.value.trim()) self.renderBrowse(true);

        var jobs = [];
        for (var p = 2; p <= pages; p++) {
          jobs.push(
            self.fetchJson(self.browseUrl + '&page=' + p)
              .catch(function () { return { results: [] }; })
          );
        }
        return Promise.all(jobs).then(function (rest) {
          rest.forEach(function (r) {
            self.index = self.index.concat(r.results || []);
          });
          self.indexComplete = true;
          self.sortIndex();
          self.cacheIndex();
          return self.index;
        });
      })
      .catch(function () {
        /* Index unavailable — live search still works on its own. */
        self.index = [];
        self.indexComplete = false;
        return self.index;
      });
  };

  ManualsLibrary.prototype.sortIndex = function () {
    this.index.sort(function (a, b) {
      return String(a.t).localeCompare(String(b.t), undefined, { sensitivity: 'base' });
    });
  };

  ManualsLibrary.prototype.cacheIndex = function () {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(this.index)); }
    catch (e) { /* over quota or blocked — the page works without the cache */ }
  };

  /* ---- Input handling ------------------------------------------------ */

  ManualsLibrary.prototype.onInput = function (immediate) {
    var q = this.input.value.trim();
    this.term = q;
    this.classList.toggle('is-searching', q.length > 0);
    this.writeQueryParam(q);

    clearTimeout(this.timer);
    if (this.controller) { this.controller.abort(); this.controller = null; }

    if (!q) { this.renderBrowse(); return; }
    if (q.length < MIN_CHARS) {
      this.setStatus('Keep typing — at least ' + MIN_CHARS + ' characters.');
      return;
    }

    /* Instant answer off the cached index, then let the server refine it. */
    var local = this.filterLocal(q);
    this.renderResults(this.merge(local, [], q), q, null);

    var self = this;
    var run = function () { self.serverSearch(q, local); };
    if (immediate) run(); else this.timer = setTimeout(run, DEBOUNCE_MS);
  };

  ManualsLibrary.prototype.filterLocal = function (q) {
    if (!this.index || !this.index.length) return [];
    var nq = norm(q);
    var lq = q.toLowerCase();
    return this.index.filter(function (m) {
      return (
        String(m.t).toLowerCase().indexOf(lq) !== -1 ||
        String(m.c).toLowerCase().indexOf(lq) !== -1 ||
        norm(m.s).indexOf(nq) !== -1
      );
    });
  };

  /* ---- Live search --------------------------------------------------- */

  ManualsLibrary.prototype.serverSearch = function (q, local) {
    var self = this;
    var controller = new AbortController();
    this.controller = controller;

    var base = this.searchUrl + '&q=' + encodeURIComponent(q);
    var collected = [];
    var skipped = 0;

    var walk = function (page, pages) {
      return self.fetchJson(base + '&page=' + page, controller.signal).then(function (data) {
        collected = collected.concat(data.results || []);
        skipped += data.skipped || 0;
        var total = pages || data.pages || 1;
        var more = page < Math.min(total, SEARCH_PAGE_CAP);
        if (more && collected.length < SEARCH_WANT) return walk(page + 1, total);
        return null;
      });
    };

    walk(1, null)
      .then(function () {
        if (self.term !== q) return; /* a newer keystroke owns the view now */
        self.renderResults(self.merge(local, collected, q), q, skipped);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        /* Server search failed — the local result set is already on screen,
           so say nothing louder than a footnote. */
        if (self.term === q && (!local || !local.length)) {
          self.setStatus('Search is temporarily unavailable. Try a product name, or contact us.');
        }
      });
  };

  ManualsLibrary.prototype.merge = function (a, b, term) {
    var seen = Object.create(null);
    var out = [];
    (a || []).concat(b || []).forEach(function (m) {
      if (!m || !m.p) return;
      /* Search results carry ?_pos/_sid tracking on the product URL, browse
         results don't — key on the PDF plus the path only, or the same
         manual shows up twice. */
      var key = String(m.u).split('?')[0] + '|' + m.p;
      if (seen[key]) return;
      seen[key] = true;
      out.push(m);
    });

    if (!term) {
      out.sort(function (x, y) {
        return String(x.t).localeCompare(String(y.t), undefined, { sensitivity: 'base' });
      });
      return out;
    }

    /* Local hits are unshifted in first and the server's are appended in its
       own relevance order, so index order is already a sensible tiebreak. */
    var lq = term.toLowerCase();
    var nq = norm(term);
    var ranked = out.map(function (m, i) { return { m: m, i: i, s: score(m, lq, nq) }; });
    ranked.sort(function (x, y) { return (y.s - x.s) || (x.i - y.i); });
    return ranked.map(function (r) { return r.m; });
  };

  /* ---- Rendering ----------------------------------------------------- */

  ManualsLibrary.prototype.setStatus = function (html) {
    this.statusEl.innerHTML = html;
  };

  ManualsLibrary.prototype.itemHtml = function (m, term) {
    var sku = String(m.s || '').split(' ')[0];
    var meta = [];
    if (m.c) meta.push(highlight(m.c, term));
    if (sku) meta.push('<span class="manuals__sku">' + highlight(sku, term) + '</span>');

    return (
      '<li class="manuals__item">' +
        (m.i
          ? '<img class="manuals__thumb" src="' + esc(m.i) + '" alt="" loading="lazy" width="64" height="64">'
          : '<span class="manuals__thumb" aria-hidden="true"></span>') +
        '<div class="manuals__body">' +
          '<p class="manuals__title"><a href="' + esc(m.u) + '">' + highlight(m.t, term) + '</a></p>' +
          (meta.length ? '<p class="manuals__meta">' + meta.join(' &middot; ') + '</p>' : '') +
        '</div>' +
        '<a class="manuals__action" href="' + esc(m.p) + '" target="_blank" rel="noopener">' +
          FILE_ICON + '<span>' + esc(m.l || 'View manual') + '</span>' +
          '<span class="visually-hidden">for ' + esc(m.t) + ' (opens in a new tab)</span>' +
        '</a>' +
      '</li>'
    );
  };

  ManualsLibrary.prototype.renderBrowse = function (partial) {
    var list = this.index || [];
    if (!list.length) {
      if (partial) return;
      this.setStatus('');
      this.results.innerHTML =
        '<div class="manuals__empty">' +
          '<h3>Manuals are loading slowly</h3>' +
          '<p>Search for your product by name or SKU above, or refresh the page.</p>' +
        '</div>';
      return;
    }

    this.setStatus(
      '<b>' + list.length + '</b> manual' + (list.length === 1 ? '' : 's') + ' available' +
      (partial ? ' so far&hellip;' : '')
    );

    var html = '';
    var letter = '';
    for (var i = 0; i < list.length; i++) {
      var first = String(list[i].t || '#').charAt(0).toUpperCase();
      if (!/[A-Z]/.test(first)) first = '#';
      if (first !== letter) {
        if (letter) html += '</ul>';
        letter = first;
        html += '<h2 class="manuals__letter">' + esc(letter) + '</h2><ul class="manuals__list">';
      }
      html += this.itemHtml(list[i], '');
    }
    if (letter) html += '</ul>';
    this.results.innerHTML = html;
  };

  ManualsLibrary.prototype.renderResults = function (list, term, skipped) {
    if (!list.length) {
      this.setStatus('');
      this.results.innerHTML =
        '<div class="manuals__empty">' +
          '<h3>No manual found for &ldquo;' + esc(term) + '&rdquo;</h3>' +
          '<p>Not every product has a manual online yet. Try the product name as it ' +
          'appears on your order (for example <em>ANDRIA</em>), or the SKU printed on ' +
          'the carton label.</p>' +
          (skipped
            ? '<p><b>' + skipped + '</b> product' + (skipped === 1 ? '' : 's') +
              ' matched your search but ' + (skipped === 1 ? 'has' : 'have') +
              ' no manual on file — get in touch and we’ll send it to you.</p>'
            : '') +
        '</div>';
      return;
    }

    var msg = '<b>' + list.length + '</b> manual' + (list.length === 1 ? '' : 's') +
              ' for &ldquo;' + esc(term) + '&rdquo;';
    if (skipped) {
      msg += ' &middot; ' + skipped + ' other match' + (skipped === 1 ? '' : 'es') +
             ' ' + (skipped === 1 ? 'has' : 'have') + ' no manual online yet';
    }
    this.setStatus(msg);

    var html = '<ul class="manuals__list">';
    for (var i = 0; i < list.length; i++) html += this.itemHtml(list[i], term);
    html += '</ul>';
    this.results.innerHTML = html;
  };

  customElements.define('manuals-library', ManualsLibrary);
})();
